import {
  useLocation,
  useNavigate,
  // useSearchParams
} from 'react-router-dom';
import {
  Badge,
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  alpha,
  // useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  LuChevronDown,
  LuBuilding2,
  LuBell,
} from 'react-icons/lu';
import AppIcon from '../icons/app-icon';
import ThemeModeToggle from '../shared/theme-mode-toggle/theme-mode-toggle';
import './topnav.scss';
import DigitalClock from './digital-clock';
import { useContext, useState, useEffect } from 'react';
import { useMutateQuery } from '../../hooks/useMutateQuery';
import { useWhatsNew } from '../../features/whats-new/hooks/useWhatsNew';
import {
  getGreeting,
  AnimatedEmoji,
} from '../../components/shared/greeting/greeting';

import {
  GlobalStateContext,
  GlobalStateContextType,
} from '../../context/global-state-context';
import { storeAuthSession } from '../../auth/token-storage';
const TopNav = () =>
  // { toggleSidebar }: any
  {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    // Live clock — drives the navbar greeting + time and keeps it current as
    // the hour (and therefore the greeting) changes.
    const [now, setNow] = useState(() => new Date());
    // Frozen per page load: the cheeky subtitle changes on refresh but not on
    // every 30s clock tick.
    const [greetingSeed] = useState(() => Math.random());
    useEffect(() => {
      const id = setInterval(() => setNow(new Date()), 30000);
      return () => clearInterval(id);
    }, []);
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const { user } = useContext(GlobalStateContext) as GlobalStateContextType;
    const greeting = getGreeting(now, user?.username, greetingSeed);

    // Get active organization from localStorage (same source as menu).
    // Dedupe by organizationId — the stored user can contain the same org more
    // than once, which otherwise renders a duplicate (and double-selected) entry.
    const activeOrgId = localStorage.getItem('orgId');
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    const organizations = (storedUser?.userOrganizations || []).filter(
      (org, i, arr) =>
        arr.findIndex((o) => o.organizationId === org.organizationId) === i
    );
    const activeOrg = organizations.find(
      (org) => org.organizationId === activeOrgId
    );

    // const [searchParams] = useSearchParams();

    // const isSmallerScreen = useMediaQuery('(max-width: 600px)');

    const { hasNewUpdates } = useWhatsNew();
    const [showBadge, setShowBadge] = useState(hasNewUpdates);

    useEffect(() => {
      setShowBadge(hasNewUpdates);
      const handler = () => setShowBadge(false);
      window.addEventListener('whats-new-seen', handler);
      return () => window.removeEventListener('whats-new-seen', handler);
    }, [hasNewUpdates]);

    const { mutate: orgLogin } = useMutateQuery();

    // const curPath = location.pathname.split('/')[1];

    // const headerView = (header: string) => {
    //   if (header === '') return 'Projects';
    //   header = header.charAt(0).toUpperCase() + header.slice(1).toLowerCase();
    //   header = header.replace('-', ' ');

    //   return header;
    // };

    return (
      <Box
        className='topnav'
        sx={{
          mb: 0,
          backgroundColor: theme.palette.background.default,
        }}
      >
        {/* <LightTooltip
        title={
          !isSmallerScreen && (iconDirection ? "Open Sidebar" : "Close Sidebar")
        }
        placement="right"
      >
        <div className="sidebar-toggle" onClick={handleSidebarClick}>
          {!iconDirection ? (
            <KeyboardArrowLeftRoundedIcon className="icon-sidebar" />
          ) : (
            <KeyboardArrowRightRoundedIcon className="icon-sidebar" />
          )}
        </div>
      </LightTooltip> */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box>
            <Typography
              variant='h2'
              className='header-label'
              sx={{
                color: theme.palette.text.primary,
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
              }}
            >
              {greeting.heading}
              <AnimatedEmoji kind={greeting.kind} fontSize='0.95em' animate={false} />
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                mt: 0.25,
                flexWrap: 'wrap',
              }}
            >
              <Typography
                variant='caption'
                sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}
              >
                {greeting.subtitle}
              </Typography>
              <Box
                component='span'
                sx={{ color: 'text.disabled', lineHeight: 1 }}
              >
                ·
              </Box>
              <DigitalClock />
            </Box>
          </Box>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'space-between',
              gap: '10px',
              cursor: 'pointer',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'space-between',
                gap: '10px',
                cursor: 'pointer',
              }}
              onClick={handleClick}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                }}
              >
                <Typography
                  variant='h2'
                  className='header-label'
                  sx={{
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                  }}
                >
                  {user.username}
                </Typography>
                {activeOrg && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      mt: '2px',
                    }}
                  >
                    <AppIcon
                      icon={LuBuilding2}
                      size={14}
                      color='text.secondary'
                    />
                    <Typography
                      variant='caption'
                      sx={{
                        color: theme.palette.text.secondary,
                        fontSize: '12px',
                      }}
                    >
                      {activeOrg.organization.orgName}
                    </Typography>
                  </Box>
                )}
              </Box>
              <AppIcon icon={LuChevronDown} size={18} color='text.secondary' />
            </div>
            <IconButton
              onClick={() => navigate('/whats-new')}
              size='small'
              sx={{
                color: showBadge
                  ? theme.palette.primary.main
                  : theme.palette.text.secondary,
                '&:hover': {
                  bgcolor: alpha(theme.palette.primary.main, 0.12),
                  color: theme.palette.primary.main,
                },
              }}
            >
              <Badge
                variant='dot'
                invisible={!showBadge}
                sx={{
                  '& .MuiBadge-badge': {
                    bgcolor: theme.palette.error.main,
                    width: 8,
                    height: 8,
                    minWidth: 8,
                  },
                }}
              >
                <AppIcon icon={LuBell} size={20} />
              </Badge>
            </IconButton>
            <ThemeModeToggle size='small' />
          </div>
          <Menu
            id='basic-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {organizations.map((org) => {
                return (
                  <MenuItem
                    key={org.organizationId}
                    selected={
                      org.organizationId === localStorage.getItem('orgId')
                    }
                    onClick={() => {
                      orgLogin(
                        {
                          url: `/auth/organization-login`,
                          method: 'post',
                          body: {
                            organizationId: org.organizationId,
                            oldToken: localStorage.getItem('token'),
                          },
                        },
                        {
                          onSuccess: (data) => {
                            storeAuthSession(data, org.organizationId);
                            handleClose();
                            const basePath = location.pathname;

                            if (basePath !== '/events') {
                              navigate('/events', { replace: true });
                              window.location.reload();
                            } else {
                              window.location.reload();
                            }
                          },
                        }
                      );
                    }}
                  >
                    <ListItemIcon>
                      <AppIcon icon={LuBuilding2} fontSize='small' />
                    </ListItemIcon>
                    <ListItemText>{org.organization.orgName}</ListItemText>
                  </MenuItem>
                );
              }
            )}
          </Menu>
        </div>
      </Box>
    );
  };

export default TopNav;
